import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { DateFormat } from 'src/shared/models/enums';
import { DateHelperService } from 'src/shared/services/helpers/date-helper.service';

@Injectable({
	providedIn: 'root'
})
export class SharedBookingAccessHelperService {
	facilityName = '';
	additionalInfo = '';
	booking

	constructor(private translateService: TranslateService,) {
	}

	setInfoData(booking) {
		this.facilityName = booking.towerGroupName;
		this.booking = booking;
		this.additionalInfo =
			`${ this.translateService.instant('booking.title') } ${ booking.id },
					 ${ DateHelperService.convertDate(new Date(booking.startDate), 'default', DateFormat.ForDisplay) }`
	}

	checkIfSharingIsActive(start, end, status) {
		const isBetween = DateHelperService.isDateBetween(start, end);
		const bStatus = status === 'ACCEPTED';
		return (isBetween === true && bStatus === true);
	}
}
